import ApiService from '@/utils/ApiService'

export default {
  namespaced: true,
  state: {
    isLoading: false,
    updated: null,
    violations: {}
  },
  getters: {
    isLoading: (state) => state.isLoading,
    updated: (state) => state.updated,
    violations: (state) => state.violations
  },
  mutations: {
    toggleLoading (state) {
      state.isLoading = !state.isLoading
    },
    setUpdated (state, updated) {
      state.updated = updated
    },
    reset (state) {
      state.updated = null
      state.isLoading = false
      state.violations = {}
    },
    setViolations (state, violations) {
      state.violations = violations
    }
  },
  actions: {
    async update ({ commit }, data) {
      commit('toggleLoading')
      const response = await new ApiService(data['@id']).put(data)
      if (response.status < 300) commit('setUpdated', response.json)
      else commit('setViolations', response)
      commit('toggleLoading')
    },
    reset ({ commit }) {
      commit('reset')
    }
  }
}
